import CloseOutlined from "@mui/icons-material/CloseOutlined"
import { Box, Drawer, Grid, IconButton, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"

import { useEffect } from "react"
import { AppDispatch } from "../../../store"
import {
	closeDrawer,
	ICorporateEditState,
} from "../../../store/corporates/corporate-edit-slice"
import { RootState } from "../../../store/reducers"
import CreateForm from "./form"
const CorporateDrawer = () => {
	const dispatch = useDispatch<AppDispatch>()
	const {
		isDrawerOpen,
		isEditMode,
		tabIndex,
		currentCorporate,
	}: ICorporateEditState = useSelector(
		(state: RootState) => state.corporateEdit
	)

	const handleClose = () => {
		dispatch(closeDrawer())
	}

	useEffect(() => {
		return () => {
			dispatch(closeDrawer())
		}
	}, [])

	return (
		<Drawer anchor="right" open={isDrawerOpen} onClose={handleClose}>
			<Grid p={2} container justifyContent={"space-between"}>
				<Grid item flexGrow={1}>
					<Typography component="span" variant="h6">
						{isEditMode
							? `Modifica Corporate ${currentCorporate?.corporateSenderName}`
							: "Crea Nuova corporate"}
					</Typography>
				</Grid>
				<Grid item>
					<IconButton
						onClick={() => handleClose()}
						sx={{ width: "30px", height: "30px" }}
					>
						<CloseOutlined />
					</IconButton>
				</Grid>
			</Grid>
			<Box p={2} sx={{ minWidth: "360px", width: "40vw" }}>
				<CreateForm
					isEditMode={isEditMode}
					corporate={currentCorporate}
					tabIndex={tabIndex}
				/>
			</Box>
		</Drawer>
	)
}

export default CorporateDrawer
